import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import InteractiveLoader from '~/src/components/InteractiveLoader';
import { useStorageAddress } from '~/src/features/full-buy/ContactAddress/useStorageAddress';
import { initializationAgreement } from '~/src/features/tariffBuilder/actions/thunk';
import { useCtxDispatch } from '~/src/features/tariffBuilder/hooks';
import { TState } from '~/src/store';
import { selectCsrf } from '~/src/store/selectors/auth/selectCsrf';

const agreementCreationStatuses = [
    'Создаем заявку...',
    'Проверяем данные...',
    'Добавляем заявку в базу...',
    'Защищаем ваши данные...',
    'Передаем информацию...',
    'Боремся с бюрократией...',
    'Ищем свободного инженера...',
    'Проверяем доступные дату и время...',
    'Ещё немного формальностей...',
];

const CreateAgreementContainer = (): JSX.Element => {
    const dispatch = useCtxDispatch();

    const { address, providerId, domain, csrf } = useSelector((state:TState) => ({
        address: state.contactAddress.verifiedAddressData,
        providerId: state.city.provider.providerId,
        domain: state.city.currentCity.domain,
        csrf: selectCsrf(state),
    }));

    useStorageAddress();

    useEffect(() => {
        dispatch(initializationAgreement(providerId, domain, address, csrf));
    }, [providerId, domain, address]);

    return (
        <InteractiveLoader
            textItems={agreementCreationStatuses}
            delay={10}
            loopSegmentAtIndex={5}
        />
    );
};

export default CreateAgreementContainer;
